/* vn-clarine.js — comportamento do tema estilo clarine.co (Vanetto, 21/10/2026)
   Fonte no brain: vanetto/tema/assets/vn-clarine.js
   1. Entrada suave das secoes ao rolar (sobe 20px e aparece, em escada), como a Clarine. So anima o que esta
      ABAIXO da dobra no carregamento: nada que ja esta na tela pisca. Respeita "reduzir movimento".
   2. Caixa da oferta da PDP (snippets/vn-cl-pdp.liquid, part 'offer'): barra e frase acompanham o carrinho.
   3. Mix and match da PDP (part 'upsell'): troca de cor e botao Add pelo mesmo caminho do par da home
      (add.js simples = 1 "add to cart"; depois variant:add + cart:change pro tema abrir a gaveta e a caixa
      brinde se ajeitar). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. entrada ao rolar ---------- */
  /* Nada que mora dentro de faixa de deslizar pro lado (cards da descricao, colecoes, journal): o deslocamento de 20px
     da entrada vira sobra rolavel na vertical dentro da faixa (21/10, ele viu a fileira "subir" no celular). */
  var REVEAL = [
    '.shopify-section--rich-text .prose',
    '.shopify-section--image-with-text-overlay .content-over-media > :not(img):not(picture):not(video):not(video-media)',
    '.shopify-section--faq .accordion',
    '.shopify-section--faq .section-stack__intro',
    '.shopify-section--apps .shopify-app-block',
    '.vps__lead-copy', '.vps__split'
  ].join(',');

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var vh = window.innerHeight || 800;
    var els = Array.prototype.slice.call(document.querySelectorAll(REVEAL));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vnc-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var groups = new Map();
    els.forEach(function (el) {
      if (el.closest('[reveal-on-scroll]') || el.getBoundingClientRect().top < vh) return; /* o tema ja anima / ja esta na tela */
      var parent = el.parentElement;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      el.style.setProperty('--vnc-delay', Math.min(i, 5) * 90 + 'ms');
      el.classList.add('vnc-r');
      io.observe(el);
    });
  }

  /* ---------- 2. caixa da oferta ---------- */
  function countWatches(cart, gift) {
    var n = 0;
    (cart && cart.items || []).forEach(function (it) {
      if (it.product_type === 'Watch' && it.handle !== gift) n += it.quantity;
    });
    return n;
  }
  function paintOffer(cart) {
    document.querySelectorAll('[data-vcl-offer]').forEach(function (box) {
      var n = Math.min(countWatches(cart, box.getAttribute('data-gift')), 3);
      var fill = box.querySelector('[data-vcl-fill]');
      if (fill) fill.style.width = Math.round(n * 100 / 3) + '%';
      var bar = box.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', n);
      box.querySelectorAll('[data-vcl-step]').forEach(function (s) {
        s.classList.toggle('is-on', +s.getAttribute('data-vcl-step') <= n);
      });
      var msg = box.querySelector('[data-vcl-msg]');
      var txt = box.getAttribute('data-m' + n);
      if (msg && txt) msg.textContent = txt;
    });
  }
  function refreshOffer(e) {
    if (!document.querySelector('[data-vcl-offer]')) return;
    var cart = e && e.detail && e.detail.cart;
    if (cart && cart.items) { paintOffer(cart); return; }
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(paintOffer).catch(function () {});
  }
  document.addEventListener('cart:change', refreshOffer);
  document.addEventListener('cart:refresh', function () { setTimeout(refreshOffer, 600); });

  /* ---------- 3. mix and match ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-vcl-up-variant]');
    if (!sel) return;
    var card = sel.closest('[data-vcl-up]');
    var opt = sel.options[sel.selectedIndex];
    var btn = card.querySelector('[data-vcl-up-add]');
    btn.setAttribute('data-variant', sel.value);
    var price = card.querySelector('[data-vcl-up-price]');
    if (price) price.textContent = opt.getAttribute('data-price');
    var cmp = card.querySelector('[data-vcl-up-compare]');
    if (cmp) {
      var c = opt.getAttribute('data-compare');
      cmp.textContent = c || '';
      cmp.hidden = !c;
    }
    var img = card.querySelector('.vcl-up__img');
    var src = opt.getAttribute('data-img');
    if (img && src) { img.removeAttribute('srcset'); img.src = src; }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vcl-up-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = +btn.getAttribute('data-variant');
    var wrap = btn.closest('[data-vcl-up-root]');
    var err = wrap && wrap.querySelector('[data-vcl-up-err]');
    if (err) err.hidden = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var body = { id: id, quantity: 1, sections: sections.join(','), sections_url: root + 'variants/' + id };

    function done() { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    function fail(msg) {
      done();
      if (err) { err.textContent = msg || 'Something went wrong. Please try again.'; err.hidden = false; }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (added) {
        if (!added.ok) { fail(added.json && added.json.description); return; }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          done();
          cart.sections = added.json.sections;
          var st = window.themeVariables && themeVariables.settings;
          if (st && st.cartType === 'page') { window.location.href = root + 'cart'; return; }
          btn.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.json.items || [added.json], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        });
      })
      .catch(function () { fail(); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal);
  else initReveal();
})();
